import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { IOperationData, IPageType, ITextinputOperation } from "../../../constants/types";

import TemplatePage from "../templatePage/TemplatePage";
import OperationMinimized from "../../operations/OperationMinimized";
import TextAreaAutosize from 'react-textarea-autosize';
import FinalPage from "../finalPage/FinalPage";
import ErrorPage from "../errorPage/ErrorPage";
import { postNewSubmit } from "../../../data/apiconnect"
import './SubmitPage.scss';
import '../../operations/textInputOperation/TextInputOperation.scss'
import { verify } from "crypto";


interface Props extends WithTranslation {
    pages: {
        [index: number]: IPageType
    },
    path: number[],
    data: {
        [id: string]: IOperationData
    },
    onUndo: () => void,
    undoTo: (index: number) => void,
    onChange: (pageIndex: number, changes: IOperationData) => void
};

interface State {
    other: string;
    showPage: string;
};

const maxOtherTextLen = 1024;

class SubmitPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            other: "",
            showPage: "submitPage"
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    async onSubmit() {
        let { data } = this.props;
        let { other } = this.state;
        const date = { value: new Date().toLocaleDateString("sv-SE").slice(-8).replace(/-/g, "") }
        let sendObj: any = {}
        let numOfRooms;
        let agreementNumber;

        Object.keys(data).forEach(k => {
            if (typeof data?.[k]?.value == 'string') {
                if (k == "userType" && data?.userType?.type != "privatePerson") {
                    sendObj = { ...sendObj, ...{ [k]: { ['value']: "KOM" } } }
                } else {
                    sendObj = { ...sendObj, ...{ [k]: { ['value']: data?.[k]?.value } } }
                }
            } else {
                sendObj = { ...sendObj, ...data?.[k]?.value }
            }
        });

        numOfRooms = sendObj?.numOfRooms?.value ? "antal rum: " + sendObj?.numOfRooms?.value : ""
        agreementNumber = sendObj?.agreementNumber?.value ? "angivet avtalsnr: " + sendObj?.agreementNumber?.value : ""
        sendObj = { ...sendObj, ['name']: { value: `${sendObj?.name?.value || ''} ${sendObj?.surname?.value || ''}` } };
        sendObj = { ...sendObj, ['other']: { value: [other, numOfRooms, agreementNumber].join(", ") } };
        sendObj = { ...sendObj, date };

        let res = await postNewSubmit(sendObj);
        this.setState({ showPage: (res ? 'finalPage' : 'errorPage') })
    }

    renderInputFields(pages: { i: number, p: IPageType, d: IOperationData }[]) {
        const result = pages.map(({ i, p, d }) => {
            return <OperationMinimized key={p.id} id={p.id} title={p.title} operation={p.operation} data={d} goToPage={() => this.props.undoTo(i)} onChange={((changes) => { this.props.onChange(i, changes) })} />;
        });

        return <>{result}</>;
    }

    pageRenderer() {
        const { pages, path, data, onUndo, onChange, t } = this.props;
        const { showPage } = this.state

        const submittedPages = path.map(i => ({ i: i, p: pages[i], d: data[pages[i].id] }))
        const is_ok = submittedPages.filter(({ d }) => d.OK).length > 0;

        switch (showPage) {
            case "submitPage":
                return <TemplatePage id={'submit-page'} title={"general.confirm-information"} onUndo={onUndo} nextEnabled={is_ok} nextTitle={"general.finalize-submission"} onNext={this.onSubmit}>
                    {this.renderInputFields(submittedPages)}

                    <div className="render-text-input-operation" style={{ marginTop: '1em' }}>
                        <p style={{ marginBottom: '0px' }} className="text-input-description fade-in">{t("general.write-other-here" as unknown as TemplateStringsArray)}</p>

                        <TextAreaAutosize
                            minRows={4}
                            placeholder={t("general.write-here")}
                            value={this.state.other}
                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }}
                            onChange={(e) => {
                                if (e.target.value.length < (maxOtherTextLen - 73))//1024-x where x is len of appended text to other
                                    this.setState({ other: e.target.value })
                            }}
                            className="text-input-input"
                        />
                    </div>
                </TemplatePage>

            case "finalPage":
                return <TemplatePage id={'final-page'} title={"general.final-information"} onUndo={onUndo} nextEnabled={is_ok} nextTitle={"general.final-information"} onNext={this.onSubmit}>
                    <FinalPage message={'general.final-information-text'} />
                </TemplatePage>

            case "errorPage":
                return <TemplatePage id={'error-page'} title={"general.error"} onUndo={onUndo} nextEnabled={is_ok} nextTitle={"general.error"} onNext={this.onSubmit}>
                    <ErrorPage message={'general.error-information-text'} />
                </TemplatePage>

            default:
                break;
        }
    }

    render() {
        const { pages, path, data, onUndo, onChange, t } = this.props;

        return this.pageRenderer();
    }
};

export default withTranslation()(SubmitPage);